import React from 'react'
import { Box } from 'grid-styled'
import { TagBadge } from 'components'


const TagBadgeCloud = ({ tags, filterTag, ...rest }) => (
  <Box {...rest}>
    {tags.map(tag => {
      const active = !filterTag ? false : tag.id === filterTag.id
      return (
        <TagBadge mr={3} mt={2} active={active} tag={tag} key={tag.id} />
      )
    })}
  </Box>
)

export default TagBadgeCloud



// WEBPACK FOOTER //
// /opt/build/repo/src/components/TagBadgeCloud.js